import { render, staticRenderFns } from "./AlldayItem.vue?vue&type=template&id=47dd9d53"
import script from "./AlldayItem.ts?vue&type=script&lang=ts&external"
export * from "./AlldayItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports